import React from 'react';
import { useSelector } from 'react-redux';
import { FadeInImage } from '../../../../../../components/FadeInImage';
import './style.scss';

export const FlagPlaceholder = ({ textContent }) => {
  const { matches_result_placehoderFlag_img: flagPlaceholder } = useSelector(
    state => state.asset,
  );

  return (
    <div className="flag-placeholder">
      <FadeInImage
        classNames={['flag-placeholder__img']}
        imageSrc={flagPlaceholder}
        imageAlt="mundial flag"
        width={27}
        height={32}
      />
      <span className="flag-placeholder__name">{textContent}</span>
    </div>
  );
};
